import React, { useEffect, useState } from "react";
import {
  Home,
  Sparkles,
  BriefcaseBusiness,
  FolderKanban,
  MessageSquareQuote,
  GraduationCap,
  Award,
  Mail,
} from "lucide-react";

import { ExpandableTabs } from "./ui/expandable-tabs";

const tabs = [
  {
    title: "Home",
    href: "#home",
    icon: Home,
  },
  {
    title: "Capabilities",
    href: "#capabilities",
    icon: Sparkles,
  },
  {
    title: "Experience",
    href: "#experience",
    icon: BriefcaseBusiness,
  },
  {
    title: "Projects",
    href: "#projects",
    icon: FolderKanban,
  },
  {
    title: "Testimonials",
    href: "#testimonials",
    icon: MessageSquareQuote,
  },
  {
    title: "Education",
    href: "#education",
    icon: GraduationCap,
  },
  {
    title: "Certificates",
    href: "#certificates",
    icon: Award,
  },
  {
    title: "Contact",
    href: "#contact",
    icon: Mail,
  },
];

export default function CustomColorDemo() {
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    const sections = tabs
      .map((tab) => document.querySelector(tab.href))
      .filter(Boolean);

    if (!sections.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const visibleSections = entries
          .filter((entry) => entry.isIntersecting)
          .sort(
            (a, b) =>
              b.intersectionRatio - a.intersectionRatio
          );

        if (visibleSections.length > 0) {
          const activeId = `#${visibleSections[0].target.id}`;

          const index = tabs.findIndex(
            (tab) => tab.href === activeId
          );

          if (index !== -1) {
            setActiveTab(index);
          }
        }
      },
      {
        rootMargin: "-25% 0px -60% 0px",
        threshold: [0.1, 0.25, 0.5],
      }
    );

    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);

  return (
    <ExpandableTabs
      tabs={tabs}
      activeColor="text-[#D4AF37]"
      className="md:top-6 top-3"
      onChange={(index) => {
        setActiveTab(index);
      }}
    />
  );
}
